/**
 * Known-errors reference dictionary for Velove projects
 *
 * @important those are *meant* to be shown in the UI!
 */
export const dictionary = {
  'user.id.not-found': 'This user does not exists.',
  'user.email.invalid': 'This email is invalid.',
  'user.email.duplicate': 'This email is already used.',
  'user.personal-identification-number.duplicate': 'This social security number is already used',
  'user.hubs.empty': 'The list of hubs cannot be empty.',
  'user.hubs.permissions': 'User does not have access to hub(s)',
  'user.status.not-available': 'The user does not have the "available" status.',
  'shift.rider.double-assignment': 'This rider is already assigned to that shift'
};
